<template>
  <plan-select-page
    header="Select a Plan to Rejoin"
    :selectable-plans="selectablePlans"
    :breadcrumb="{ name: 'Rejoin', to: 'rejoin' }"/>
</template>

<script>
import PlanSelectPage from './PlanSelectPage'
import MembershipMixin from './MembershipMixin'

export default {
  name: 'RejoinPage',
  components: { PlanSelectPage },
  mixins: [MembershipMixin],
  computed: {
    selectablePlans () {
      if (!this.membershipPlans) {
        return []
      }
      return this.membershipPlans.filter(plan => !plan.prepayment)
    }
  }
}
</script>

